(function () {
  'use strict';

  function formatComboMoney(cents) {
    if (typeof formatMoney === 'function' && window.themeVariables && window.themeVariables.settings) {
      var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      return formatMoney(cents, currencyFormat);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '\u20B9' + (cents / 100).toFixed(0);
  }

  function findVariant(variants, selections) {
    return variants.find(function (variant) {
      if (selections[0] && variant.option1 !== selections[0]) return false;
      if (selections[1] && variant.option2 !== selections[1]) return false;
      if (selections[2] && variant.option3 !== selections[2]) return false;
      return variant.available;
    });
  }

  function refreshCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cartContent) {
        if (window.RabitatCart && typeof window.RabitatCart.notifyUpdated === 'function') {
          window.RabitatCart.notifyUpdated(cartContent);
          return cartContent;
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));

        document.dispatchEvent(
          new CustomEvent('rabitat:cart:updated', {
            detail: { item_count: cartContent.item_count, cart: cartContent }
          })
        );

        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach(function (el) {
          el.textContent = cartContent.item_count;
        });

        if (window.injectGoKwikPreviews) {
          setTimeout(function () {
            window.injectGoKwikPreviews();
          }, 1000);
        }

        return cartContent;
      });
  }

  function initCombo(root) {
    var config = window.buy2ComboConfig;
    if (!config || !root) return;

    var mode = 'double';
    var overlay = document.getElementById('buy2ComboModalOverlay');
    var modal = document.getElementById('buy2ComboModal');
    var closeBtn = document.getElementById('buy2ComboModalClose');
    var submitBtn = document.getElementById('buy2ComboModalSubmit');
    var errorEl = document.getElementById('buy2ComboModalError');
    var form = config.productFormId
      ? document.getElementById(config.productFormId)
      : document.querySelector('.rabitat-product-page__form, form[is="product-form"]');
    var variantInput = form ? form.querySelector('[name="id"], [data-product-variant-id]') : document.querySelector('[name="id"]');
    var buy2PriceCents = config.buy2PriceCents || (config.buy2Price || 0) * 100;
    var stickyPriceEls = document.querySelectorAll('[data-sticky-price], .rabitat-sticky-cart__price');
    var stickyCompareEl = document.querySelector('[data-sticky-compare-price]');
    var stickyDiscountEl = document.querySelector('[data-sticky-discount]');
    var savedStickyPrice = null;

    function isDoubleModeLocal() {
      return mode === 'double';
    }

    function updateBodyModeClass() {
      document.body.classList.toggle('buy2-combo-mode-double', isDoubleModeLocal());
      document.body.classList.toggle('buy2-combo-mode-single', !isDoubleModeLocal());
    }

    function syncModeFromDom() {
      var checkedRadio = root.querySelector('input[name="buy2-combo-mode"]:checked');
      mode = checkedRadio ? checkedRadio.value : 'double';
      root.dataset.selectedMode = mode;
      updateBodyModeClass();
      updateStickyPriceForMode();
    }

    function getCurrentVariant() {
      var variantId = variantInput ? variantInput.value : config.defaultVariantId;
      return config.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
    }

    function updateStickyPriceForMode() {
      if (!stickyPriceEls.length) return;

      if (isDoubleModeLocal()) {
        if (savedStickyPrice === null && stickyPriceEls[0]) {
          savedStickyPrice = stickyPriceEls[0].textContent;
        }
        stickyPriceEls.forEach(function (el) {
          el.textContent = formatComboMoney(buy2PriceCents);
        });
        if (stickyCompareEl) stickyCompareEl.hidden = true;
        if (stickyDiscountEl) stickyDiscountEl.hidden = true;
      } else {
        var variant = getCurrentVariant();
        if (variant) {
          stickyPriceEls.forEach(function (el) {
            el.textContent = formatComboMoney(variant.price);
          });
        } else if (savedStickyPrice && stickyPriceEls[0]) {
          stickyPriceEls[0].textContent = savedStickyPrice;
        }
        savedStickyPrice = null;
        if (variant && stickyCompareEl && stickyDiscountEl) {
          if (variant.compare_at_price > variant.price) {
            stickyCompareEl.textContent = formatComboMoney(variant.compare_at_price);
            stickyCompareEl.hidden = false;
            var discountPct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            stickyDiscountEl.textContent = discountPct + '% Off';
            stickyDiscountEl.hidden = false;
          }
        }
      }
    }

    root.querySelectorAll('input[name="buy2-combo-mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        mode = this.value;
        root.dataset.selectedMode = mode;
        updateBodyModeClass();
        updateStickyPriceForMode();
      });
    });

    function getPairSelections(pairIndex) {
      var selections = [];
      if (!modal) return selections;

      config.options.forEach(function (option, optionIndex) {
        var selected = modal.querySelector(
          '.buy2-combo-modal__swatch.is-selected[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
        );
        selections.push(selected ? selected.dataset.value : '');
      });
      return selections;
    }

    function updateOptionValueLabels(pairIndex) {
      if (!modal) return;

      config.options.forEach(function (option, optionIndex) {
        var valueEl = modal.querySelector(
          '[data-buy2-option-value][data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
        );
        if (!valueEl) return;

        var selected = modal.querySelector(
          '.buy2-combo-modal__swatch.is-selected[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
        );
        valueEl.textContent = selected ? selected.dataset.value : '';
      });
    }

    function syncSwatchAvailability(pairIndex) {
      if (!modal) return;

      var selectionChanged = false;

      config.options.forEach(function (option, optionIndex) {
        modal.querySelectorAll(
          '.buy2-combo-modal__swatch[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
        ).forEach(function (swatch) {
          var testSelections = getPairSelections(pairIndex);
          testSelections[optionIndex] = swatch.dataset.value;
          var match = findVariant(config.variants, testSelections);
          swatch.hidden = !match;
        });

        var selected = modal.querySelector(
          '.buy2-combo-modal__swatch.is-selected[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
        );

        if (selected && selected.hidden) {
          selected.classList.remove('is-selected');
          var firstVisible = modal.querySelector(
            '.buy2-combo-modal__swatch:not([hidden])[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
          );
          if (firstVisible) {
            firstVisible.classList.add('is-selected');
            selectionChanged = true;
          }
        }
      });

      if (selectionChanged) {
        syncSwatchAvailability(pairIndex);
        return;
      }

      updateOptionValueLabels(pairIndex);
    }

    function bindSwatches() {
      if (!modal) return;

      modal.querySelectorAll('.buy2-combo-modal__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.hidden) return;

          var pairIndex = swatch.dataset.pair;
          var optionIndex = swatch.dataset.optionIndex;
          modal.querySelectorAll(
            '.buy2-combo-modal__swatch[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
          ).forEach(function (el) {
            el.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');
          syncSwatchAvailability(pairIndex);
        });
      });
    }

    function openModal() {
      if (!overlay || !modal) return;
      if (errorEl) {
        errorEl.classList.remove('is-visible');
        errorEl.textContent = '';
      }

      var defaultVariant = getCurrentVariant() ||
        config.variants.find(function (v) { return v.available; });

      [0, 1].forEach(function (pairIndex) {
        config.options.forEach(function (option, optionIndex) {
          var value = defaultVariant ? defaultVariant['option' + (optionIndex + 1)] : '';
          var swatches = modal.querySelectorAll(
            '.buy2-combo-modal__swatch[data-pair="' + pairIndex + '"][data-option-index="' + optionIndex + '"]'
          );
          var matched = null;

          swatches.forEach(function (el) {
            if (el.dataset.value === value && !el.hidden) matched = el;
          });

          if (!matched) {
            swatches.forEach(function (el) {
              if (!el.hidden && !matched) matched = el;
            });
          }

          swatches.forEach(function (el) {
            el.classList.toggle('is-selected', matched && el === matched);
          });
        });
        syncSwatchAvailability(pairIndex);
      });

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function getCustomizationValue(pairIndex) {
      var input = document.getElementById('buy2ComboCustom' + pairIndex);
      return input ? input.value.trim() : '';
    }

    function addBundleToCart() {
      var items = [];
      var bundleId = 'buy2_' + Date.now();
      var hasCustomization = config.enableCustomization;

      for (var pairIndex = 0; pairIndex < 2; pairIndex++) {
        var selections = getPairSelections(pairIndex);
        var variant = findVariant(config.variants, selections);

        if (!variant) {
          if (errorEl) {
            errorEl.textContent = 'Please select available variants for Pair ' + (pairIndex + 1) + '.';
            errorEl.classList.add('is-visible');
          }
          return;
        }

        var pairLabel = 'Pair ' + (pairIndex + 1);
        var customName = getCustomizationValue(pairIndex);
        var hasEngraving = hasCustomization && customName !== '';
        var properties = {
          _bundle_id: bundleId,
          _bundle_type: 'buy2-combo',
          _bundle_price: String(config.buy2Price),
          _pair: pairLabel,
          engraving_required: hasEngraving ? 'true' : 'false'
        };

        if (hasEngraving) {
          properties['Engraving Value'] = customName;
          if (variant.featured_image) {
            properties.image_url = variant.featured_image;
          }
        }

        items.push({
          id: variant.id,
          quantity: 1,
          properties: properties
        });
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding\u2026';
      }

      var addPayload = { items: items };

      if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
        addPayload = window.RabitatCart.withCartSections(addPayload);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(addPayload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          closeModal();
          if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
            window.RabitatCart.syncCartAfterAdd(Array.isArray(data.items) ? data.items[0] : data);
          } else {
            refreshCart();
          }
        })
        .catch(function (error) {
          if (errorEl) {
            var message = (error && error.description) || 'Unable to add items to cart. Please try again.';
            errorEl.textContent = message;
            errorEl.classList.add('is-visible');
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = config.submitLabel || 'Add 2 Pairs to Cart';
          }
        });
    }

    window.buy2ComboOpenModal = openModal;

    if (form && !form.__buy2ComboPatched) {
      form.__buy2ComboPatched = true;
      form.addEventListener('submit', function (event) {
        var checked = root.querySelector('input[name="buy2-combo-mode"]:checked');
        var isDouble = (checked ? checked.value : 'double') === 'double';
        if (!isDouble) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openModal();
      }, true);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal();
      });
    }
    if (submitBtn) submitBtn.addEventListener('click', addBundleToCart);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    function updateComboPricing(variant) {
      if (!variant) return;

      var buy1PriceEl = root.querySelector('[data-buy2-buy1-price]');
      var buy1CompareEl = root.querySelector('[data-buy2-buy1-compare]');
      var buy2CompareEl = root.querySelector('[data-buy2-buy2-compare]');
      var buy2PriceEl = root.querySelector('[data-buy2-buy2-price]');
      var saveEl = root.querySelector('[data-buy2-save]');
      var modalPriceEl = document.querySelector('[data-buy2-modal-price]');

      var mrpCents = variant.mrpCents || variant.compare_at_price || variant.price || 0;
      var buy2CompareCents = variant.buy2CompareCents || (mrpCents * 2);
      var saveCents = variant.saveCents != null ? variant.saveCents : (buy2CompareCents - buy2PriceCents);

      if (buy1PriceEl) buy1PriceEl.textContent = formatComboMoney(variant.price);
      if (buy1CompareEl) buy1CompareEl.textContent = formatComboMoney(mrpCents);
      if (buy2CompareEl) buy2CompareEl.textContent = formatComboMoney(buy2CompareCents);
      if (buy2PriceEl) buy2PriceEl.textContent = formatComboMoney(buy2PriceCents);
      if (modalPriceEl) modalPriceEl.textContent = formatComboMoney(buy2PriceCents);

      if (saveEl) {
        if (saveCents > 0) {
          saveEl.textContent = 'Save ' + formatComboMoney(saveCents);
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
    }

    document.addEventListener('variant:changed', function () {
      var selectedVariant = getCurrentVariant();
      if (!selectedVariant) return;

      updateComboPricing(selectedVariant);

      if (!isDoubleModeLocal()) {
        updateStickyPriceForMode();
      }
    });

    document.addEventListener('rabitat:variant:changed', function () {
      var selectedVariant = getCurrentVariant();
      if (!selectedVariant) return;

      updateComboPricing(selectedVariant);

      if (!isDoubleModeLocal()) {
        updateStickyPriceForMode();
      }
    });

    function initBuy2Countdown() {
      if (!config.countdownEnabled) return;

      var timerEl = root.querySelector('[data-buy2-countdown]');
      if (!timerEl) return;

      var storageKey = 'buy2_combo_end_' + (config.productId || 'default');
      var endTime = sessionStorage.getItem(storageKey);

      if (!endTime) {
        endTime = String(Date.now() + (config.countdownMinutes || 180) * 60 * 1000);
        sessionStorage.setItem(storageKey, endTime);
      }

      endTime = parseInt(endTime, 10);

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function tick() {
        var diff = endTime - Date.now();

        if (diff <= 0) {
          timerEl.textContent = '00h 00m 00s';
          return;
        }

        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        timerEl.textContent = pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
      }

      tick();
      window.setInterval(tick, 1000);
    }

    bindSwatches();
    syncModeFromDom();
    updateComboPricing(getCurrentVariant());
    initBuy2Countdown();

    if (window.__buy2ComboPendingOpen) {
      window.__buy2ComboPendingOpen = false;
      openModal();
    }
  }

  function boot() {
    if (!window.buy2ComboConfig) return;
    document.querySelectorAll('[data-buy2-combo-root]').forEach(initCombo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
